<template>
    <Transition>
        <div class="w-100 h-100 d-flex justify-content-center align-items-center pre-loader bg-dark flex-column" v-if="visible">
            <div class="loader" v-if="!success"></div>
            <img src="@/assets/img/download-complete.svg" style="height: 60px;" v-if="success">
            <p class="m-0 mt-2 text-light fs-4">{{ text }}</p>
        </div>
    </Transition>
</template>

<script lang="ts">
import globalModule from '@/store/modules/global.module';
import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class GeneratePdfLoader extends Vue {
    get visible() {
        return globalModule.generatePdfLoader.visible
    }

    get text() {
        return globalModule.generatePdfLoader.text
    }

    get success(){
        return globalModule.generatePdfLoader.success
    }
}
</script>

<style lang="css" scoped>
/* HTML: <div class="loader"></div> */
.loader {
  width: 50px;
  aspect-ratio: 1;
  display: grid;
  color: #fff;
  background: radial-gradient(farthest-side, currentColor calc(100% - 6px),#0000 calc(100% - 5px) 0);
  mask: radial-gradient(circle farthest-side, transparent calc(100% - 13px), #000 calc(100% - 12px));
  border-radius: 50%;
  animation: l19 2s infinite linear;
}
.loader::before,
.loader::after {    
  content: "";
  grid-area: 1/1;
  background:
    linear-gradient(currentColor 0 0) center,
    linear-gradient(currentColor 0 0) center;
  background-size: 100% 10px,10px 100%;
  background-repeat: no-repeat;
}
.loader::after {
   transform: rotate(45deg);
}

@keyframes l19 { 
  100%{transform: rotate(1turn)}
}
</style>
